import * as api from '../api';

export const fetchSurveyFormActions = api.fetchActions('survey', 'fetch-survey-form');
export const submitSurveyFormActions = api.fetchActions('survey', 'submit-form');

export const actionTypes = {
  ...fetchSurveyFormActions.actionTypes,
  ...submitSurveyFormActions.actionTypes,
};

/**
 * Returns the assigned form to fill out.
 * If the survey is expired, closed, or already completed specific error messages will be returned to indicate that.
 * @param {*} token survey token
 */
export const fetchSurveyForm = (token) =>
  api.getThunk(`/campaign-surveys/${token}`, {}, fetchSurveyFormActions, {token}, api.unauthorizedConfig);

/**
 * Submits answers to the form.
 * This is verify that the token is valid, then attempt to submit the form response on behalf of the participant.
 * @param {*} token survey token
 * @param {*} answers answers to the form
 */
export const submitSurveyForm = (token, answers) =>
  api.postThunk(`/campaign-surveys/save/${token}`, answers, submitSurveyFormActions, {token}, api.unauthorizedConfig);



// WEBPACK FOOTER //
// src/survey/survey.actions.js